/**
 *
 * @param {String} dlsKey
 * @returns {Object} as {vill,hod,sector,parcel}
 */

export default function extractCodesFromDlsKey(dlsKey) {
  const vill = dlsKey.slice(0, 4);
  const hod = dlsKey.slice(4, 7);
  const sector = dlsKey.slice(7, 10);
  const parcel = dlsKey.slice(10, 15);

  return {
    vill,
    hod,
    sector,
    parcel,
  };
}
